import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { reduxForm, formValueSelector } from "redux-form";
import { Button } from "cxa-components";
import { StringField } from "cxa-form-field";
import { injectIntl, intlShape } from "react-intl";
import { CardSection } from "@cxagroup/casper/lib/components";
import TwoFACountDown from "./TwoFACountDown";
import SwitchTwoFAMode from "./SwitchTwoFAMode";
import { getCensorEmail } from "./utils";
import messages from "../messagesDescription";
import { renderAsHTML } from "../../utils";

const VerifyTwoFAForm = props => {
  const [isOTPExpired, setIsOTPExpired] = useState(false);

  const {
    handleSubmit,
    submitting,
    validationError,
    intl,
    otp,
    isOTPSending,
    isOPTVerifying,
    twoFaModes,
    user,
  } = props;

  const updateTwoFA = () => {
    props.sendVerificationEmail(
      (user.hrAdmin && user.hrAdmin.email) || (user.employee && user.employee.email),
      props
    );
  };

  useEffect(() => {
    props.sendOTP();
  }, []); // Only run once on mount

  return (
    <CardSection>
      <section>
        <p className="fa-message-layout">
          <strong>{intl.formatMessage(messages.twoFaSetupTitle)}</strong>
        </p>
        {/* <p>
          {VERIFY_2FA_MESSAGE1}{" "}
          <span>
            {otp.twoFaMode != "Email" ? `mobile phone number ending in ` : "email address "}
          </span>
          <strong>
            {otp.twoFAMobile && otp.twoFaMode != "Email"
              ? otp.twoFAMobile.substring(otp.twoFAMobile.length - 4)
              : getCensorEmail(
                  (user.hrAdmin && user.hrAdmin.email) || (user.employee && user.employee.email)
                )}
          </strong>
          <span>
            , via <strong>{otp.twoFaMode}</strong>.
          </span>
        </p> */}
        <p>
          {renderAsHTML(
            "div",
            intl.formatMessage(
              otp.twoFaMode != "Email"
                ? messages.twoFAPhoneProvideCode
                : messages.twoFAEmailProvideCode,
              {
                value:
                  otp.twoFAMobile && otp.twoFaMode != "Email"
                    ? otp.twoFAMobile.substring(otp.twoFAMobile.length - 4)
                    : getCensorEmail(
                        (user.hrAdmin && user.hrAdmin.email) ||
                          (user.employee && user.employee.email)
                      ),
                via: otp.twoFaMode,
              }
            )
          )}
        </p>
        <p>{intl.formatMessage(messages.clickVerifyButton)}</p>
      </section>
      <form className="cxa-c-form" onSubmit={handleSubmit}>
        <div className="verify-form-container">
          <div>
            <StringField
              label={intl.formatMessage(messages.verificationCode)}
              customClass="otp-input"
              intl={intl}
              name="otp"
              autoCorrect="off"
              autoCapitalize="none"
            />
          </div>
          <div style={{ marginTop: "42px" }}>
            <Button
              style={{ width: "100%" }}
              submitting={submitting}
              disabled={isOTPExpired || isOTPSending || isOPTVerifying}
            >
              {intl.formatMessage(messages.verifyCodeBtn)}
            </Button>
          </div>
        </div>
        <div>
          {otp.expireInSeconds > 0 && !isOTPExpired && !isOTPSending && !isOPTVerifying && (
            <TwoFACountDown expireInSeconds={otp.expireInSeconds} setOTPExpired={setIsOTPExpired} intl={intl} />
          )}
        </div>
        <SwitchTwoFAMode twoFaModes={twoFaModes || []} setOTPExpired={setIsOTPExpired} />
        <div className="error-container">
          {validationError
            ? validationError.message
            : isOTPExpired && intl.formatMessage(messages.twoFACodeExpired)}
        </div>

        <br />
        <Button
          secondary
          type="button"
          disabled={submitting}
          className="form-btn"
          onClick={updateTwoFA}
        >
          {intl.formatMessage(messages.twoFAUpdatePhoneNumberBtn)}
        </Button>
      </form>
    </CardSection>
  );
};

VerifyTwoFAForm.propTypes = {
  submitting: PropTypes.bool,
  validationError: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  handleSubmit: PropTypes.func.isRequired,
  otp: PropTypes.object,
  user: PropTypes.shape({
    hrAdmin: PropTypes.object,
    employee: PropTypes.object,
  }),
  intl: intlShape.isRequired,
  isOTPSending: PropTypes.bool,
  isOPTVerifying: PropTypes.bool,
  sendOTP: PropTypes.func,
  sendVerificationEmail: PropTypes.func,
  twoFaModes: PropTypes.array,
};
const selector = formValueSelector("verifyTwoFAForm");
const VerifyTwoFAReduxForm = connect(state => {
  // can select values individually
  const code = selector(state, "otp");
  return {
    code,
  };
})(
  reduxForm({
    form: "verifyTwoFAForm",
    enableReinitialize: true,
  })(VerifyTwoFAForm)
);

export default withRouter(injectIntl(VerifyTwoFAReduxForm));



// WEBPACK FOOTER //
// ./components/twoFA/VerifyTwoFAForm.js